'use client';

import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-cards';

const CARDS = [
	{
		emoji: '👗',
		bg: '#e8e0d4',
		title: 'New From Ralph Lauren Collection',
		sub: 'The latest collection, just arrived',
		cta: 'Lauren',
	},
	{
		emoji: '🧥',
		bg: '#d4dce8',
		title: 'New From Ralph Lauren Purple Label',
		sub: 'Holiday favorites for every event',
		cta: 'Lauren Purple',
	},
	{
		emoji: '👠',
		bg: '#e8d4d4',
		title: 'Shoes & Accessories',
		sub: 'Step into the new season',
		cta: 'Shop Shoes',
	},
	{
		emoji: '🏠',
		bg: '#d4e8d8',
		title: 'Ralph Lauren Home',
		sub: 'Refined living, reimagined',
		cta: 'RL Home',
	},
	{
		emoji: '🕶️',
		bg: '#e8e4d4',
		title: 'Summer Essentials',
		sub: 'Sun-ready styles for every occasion',
		cta: 'Shop Now',
	},
];

export default function SwiperCard() {
	const swiperRef = useRef(null);
	const [activeIndex, setActiveIndex] = useState(0);

	const handleCardClick = () => {
		const swiper = swiperRef.current;
		if (!swiper) return;

		if (swiper.activeIndex === CARDS.length - 1) {
			swiper.slideTo(0); // last → back to first
		} else {
			swiper.slideNext(); // normal advance
		}
	};

	return (
		<div className='min-h-screen bg-[#f2f2f7] flex items-center justify-center p-6'>
			<div style={{ width: '340px !important' }}>
				{/* Sender header */}
				<div className='flex items-center gap-2.5 mb-2.5'>
					<div className='w-9 h-9 rounded-full bg-black flex items-center justify-center text-white text-xs font-semibold italic flex-shrink-0'>
						S
					</div>
					<div>
						<p className='text-[13px] font-semibold text-gray-900'>
							Saks Fifth Av...
						</p>
						<p className='text-[11px] text-gray-500'>Business</p>
					</div>
				</div>

				{/* Counter */}
				<p className='text-[13px] text-gray-500 mb-3'>
					🗂 {activeIndex + 1} of {CARDS.length}
				</p>

				{/* Swiper */}
				<Swiper
					onSwiper={(swiper) => {
						swiperRef.current = swiper;
						setActiveIndex(swiper.activeIndex); // ← sync on init
					}}
					onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
					effect='cards'
					grabCursor
					modules={[EffectCards]}
					cardsEffect={{
						slideShadows: false,
						perSlideOffset: 8,
						perSlideRotate: 4,
					}}
					className='w-full h-[310px]'
				>
					{CARDS.map((card, i) => (
						<SwiperSlide
							key={i}
							onClick={handleCardClick}
							className='rounded-[18px] overflow-hidden bg-white shadow-md cursor-pointer select-none'
						>
							<div
								className='w-full h-[345px] flex items-center justify-center text-5xl'
								style={{ background: card.bg }}
							>
								{card.emoji}
							</div>

							<div className='p-4'>
								<div className='flex items-start justify-between gap-2'>
									<p className='text-[17px] font-bold text-gray-900 leading-snug flex-1'>
										{card.title}
									</p>
									<span className='text-gray-400 text-lg mt-0.5 flex-shrink-0'>
										›
									</span>
								</div>
								<p className='text-[13px] text-gray-500 mt-1 mb-3.5'>
									{card.sub}
								</p>
								<button
									onClick={(e) => e.stopPropagation()}
									className='flex items-center gap-2 px-3.5 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-full text-[13px] font-medium text-gray-800 transition-colors'
								>
									{card.cta}
									<span className='text-[10px] opacity-40'>⊕</span>
								</button>
							</div>
						</SwiperSlide>
					))}
				</Swiper>

				{/* Dot indicators */}
				<div className='flex items-center justify-center gap-1.5 mt-3.5'>
					{CARDS.map((_, i) => (
						<div
							key={i}
							onClick={() => swiperRef.current?.slideTo(i)}
							className='h-1.5 rounded-full transition-all duration-300 cursor-pointer'
							style={{
								width: i === activeIndex ? 16 : 6,
								background: i === activeIndex ? '#555' : '#bbb',
							}}
						/>
					))}
				</div>
			</div>
		</div>
	);
}
